import axios, {axiosNoSession} from "../config/axiosAuth";
import CommonHeaders from "./commonHeaders";

export const getAllCountrie=()=>{
  return axiosNoSession.get("/rule-engines-api/v1/countries/getRegistrationCountries?host=visaero")
}

export const userRegistration = (userObj) => {
  return axiosNoSession.post("user-mgmt-api/v1/visa-lancer/registerVisaLancer", userObj);
};
export const userRegistrationNew = (userObj) => {
  return axiosNoSession.post("user-mgmt-api/v1/visa-lancer/registerNewVisaLancer", userObj);
};


export const userOTPVerification = (userId) => {
  return axiosNoSession.post("/user-mgmt-api/v1/visa-lancer/verifyOtp", userId);
};

export const userOTPResend = (user_id) => {
  return axiosNoSession.post("/user-mgmt-api/v1/visa-lancer/resend-otp", user_id);
};
export const userResendEmailOTP = (user_id) => {
  return axiosNoSession.post("/user-mgmt-api/v1/visa-lancer/resendEmailOTP", user_id);
};

export const userSetPassword = (user_id, object) => {
  return axiosNoSession.patch(
    `/user-mgmt-api/v1/visa-lancer/setVisaLancerUserPassword/${user_id}`,
    object
  );
};

export const checkMobilExist = (userObject) => {
  return axiosNoSession.post(
    "/user-mgmt-api/v1/visa-lancer/checkMobileExist",
    userObject
  );
};
export const checkEmailExist = (userObject) => {
  return axiosNoSession.post(
    "/user-mgmt-api/v1/visa-lancer/checkEmailExist",
    userObject
  );
};

export const userLogin = (userObject) => {
  return axiosNoSession.post(
    `/user-mgmt-api/v1/visa-lancer/login`,
    userObject,
    CommonHeaders()
  );
};
export const userLoginWithEmail = (userObject) => {
  return axiosNoSession.post(
    `/user-mgmt-api/v1/visa-lancer/loginWithEmail`,
    userObject,
    CommonHeaders()
  );
};

export const userLogOut = (user_id, session_id) => {
  return axios.post(
    "/user-mgmt-api/v1/visa-lancer/logout",
    {
      user_id,
      session_id,
    },
    CommonHeaders()
  );
};
